import {
  LabeledFilter,
  getFilterStore,
} from "../../../components/dataGridFilter/createFilterStore";

export type FilterValue = {
  field: string;
  value: string | boolean;
};

export const getOrderFilterStore = (filterValue: FilterValue) => {
  const isAll = filterValue.field === "all";
  const key = isAll
    ? "orders"
    : `orders-${filterValue.field + filterValue.value}`;

  const initialFilters: Record<string, LabeledFilter> = isAll
    ? {}
    : {
        [filterValue.field]: {
          field: filterValue.field,
          operator: "eq",
          value: filterValue.value,
        },
      };

  return getFilterStore(initialFilters, "orders", key);
};
